




















































import Vue from 'vue'
import Component from 'vue-class-component'
import DataTable from '../components/DataTable.vue'
import CrudForm from '../components/CrudForm.vue'
import { Watch } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import {
  ArchivedPayload,
  Authority,
  AuthorityCreateInput,
  CrudDialogMode,
  CrudFieldType,
  CrudFormField,
  DataTableAction,
  DetailsField,
  DetailsFieldType,
  FetchAuthoritiesPayload,
  UpdateAuthorityPayload
} from '@/utils/types'
import { DataTableHeader } from 'vuetify'
import _ from 'lodash'
import { daysAgoInISO, stringRatio, validationRules } from '@/utils/helpers'

@Component({
  components: { DataTable, CrudForm }
})
export default class Authorities extends Vue {
  @Getter authorities!: Authority[];
  @Getter totalAuthorities!: number;
  @Action fetchAuthorities!: (payload: FetchAuthoritiesPayload) => Promise<void>;
  @Action createAuthority!: (payload: AuthorityCreateInput) => Promise<boolean>;
  @Action updateAuthority!: (payload: UpdateAuthorityPayload) => Promise<boolean>;
  @Action archiveAuthority!: (payload: ArchivedPayload) => Promise<boolean>;
  @Action activateAuthority!: (payload: UpdateAuthorityPayload) => Promise<boolean>;
  crudDialogMode = CrudDialogMode;
  currentTab = 0;
  currentCrudDialogMode = CrudDialogMode.NONE;
  headers: DataTableHeader[] = [
    { text: 'רשות', value: 'name' },
    { text: 'מעסיקים', value: 'approvedBusinessesCount', class: 'red lighten-5' },
    { text: 'מעסיקים רלוונטיים', value: 'relevantBusinessesCount', class: 'red lighten-5' },
    { text: 'מעסיקים שנרשמו ב-30 יום האחרונים', value: 'new30DaysBusinessesCount', class: 'red lighten-5' },
    { text: 'פרסומים פעילים', value: 'jobListingsCount', class: 'red lighten-5' },
    { text: 'משרות פעילות לאיוש', value: 'vacantPositionsCount', class: 'red lighten-5' },
    { text: 'בני נוער רלוונטים', value: 'relevantYouthCount', class: 'blue lighten-5' },
    { text: 'בני נוער פעילים', value: 'activeYouthCount', class: 'blue lighten-5' },
    { text: 'בני נוער שנרשמו ב-30 יום האחרונים', value: 'new30DaysYouthCount', class: 'blue lighten-5' },
    { text: 'בני נוער פעילים שרושמים שעות', value: 'hourLoggingYouthCount', class: 'blue lighten-5' },
    { text: 'יחס', value: 'ratio', class: 'purple lighten-5' },
    { text: 'הערות', value: 'shortNotes', class: 'orange lighten-5' }
  ];

  currentCrudItem: Authority = {};
  dialogFields: CrudFormField<Authority[keyof Authority]>[] = [];
  fullscreen = true
  itemsPerPage = 100;
  isLoading = false;
  snackbar = false;
  snackbarMessage = '';

  @Watch('currentTab')
  async onCurrentTabChange () {
    await this.fetchFirstPage()
  }

  async mounted () {
    await this.fetchFirstPage()
  }

  async fetchFirstPage () {
    return this.fetchPage(1)
  }

  closeDialog () {
    this.currentCrudDialogMode = CrudDialogMode.NONE
    this.dialogFields.length = 0
  }

  openDialog (mode: CrudDialogMode, item: Authority = {}) {
    this.currentCrudItem = item
    this.dialogFields.length = 0
    const getValidationsByMode = (...rules: ((value: unknown) => boolean | string)[]): ((value: unknown) => boolean | string)[] => {
      return mode === CrudDialogMode.ACTIVATE ? rules : []
    }
    if (mode === CrudDialogMode.CREATE || mode === CrudDialogMode.ACTIVATE || mode === CrudDialogMode.EDIT) {
      this.dialogFields.push({
        name: 'name',
        value: item.name || '',
        label: 'שם הרשות',
        rules: getValidationsByMode(validationRules.requiredValue),
        type: CrudFieldType.TEXT
      })
    }
    if (mode === CrudDialogMode.ACTIVATE || mode === CrudDialogMode.EDIT) {
      this.fullscreen = true
      this.dialogFields.push({
        name: 'notes',
        value: item.notes || '',
        label: 'הערות',
        type: CrudFieldType.TEXT_AREA,
        isLarge: true
      },
      {
        name: 'divider',
        value: 'divider',
        label: 'דבר הרשות',
        type: CrudFieldType.DIVIDER,
        isLarge: true
      },
      {
        name: 'mayor',
        value: item.mayor || '',
        label: 'שם ראש העיר',
        type: CrudFieldType.TEXT,
        rules: getValidationsByMode(validationRules.requiredValue)
      },
      {
        name: 'divider',
        value: '',
        label: '',
        type: CrudFieldType.DIVIDER,
        isLarge: true
      },
      {
        name: 'mayorPic',
        value: item.mayorPic || '',
        label: 'תמונת ראש העיר',
        type: CrudFieldType.IMAGE,
        rules: getValidationsByMode(validationRules.requiredFile)
      },
      {
        name: 'logo',
        value: item.logo || '',
        label: 'סמל הרשות',
        type: CrudFieldType.IMAGE,
        rules: getValidationsByMode(validationRules.requiredFile)
      },
      {
        name: 'message',
        value: item.message || '',
        label: 'דבר הרשות',
        type: CrudFieldType.TEXT_AREA,
        rules: getValidationsByMode(validationRules.requiredValue),
        isLarge: true
      },
      {
        name: 'divider',
        value: 'divider',
        label: 'מאמר מוביל',
        type: CrudFieldType.DIVIDER,
        isLarge: true
      },
      {
        name: 'leadArticle.title',
        value: item.leadArticle?.title || '',
        label: 'כותרת',
        type: CrudFieldType.TEXT,
        rules: getValidationsByMode(validationRules.requiredValue),
        isLarge: true
      },
      {
        name: 'leadArticle.subtitle',
        value: item.leadArticle?.subtitle || '',
        label: 'כותרת משנית',
        type: CrudFieldType.TEXT,
        rules: getValidationsByMode(validationRules.requiredValue),
        isLarge: true
      },
      {
        name: 'leadArticle.image',
        value: item.leadArticle?.image || '',
        label: 'תמונת מאמר',
        type: CrudFieldType.IMAGE,
        rules: getValidationsByMode(validationRules.requiredFile)
      },
      {
        name: 'leadArticle.text',
        value: item.leadArticle?.text || '',
        label: 'טקסט',
        type: CrudFieldType.TEXT_AREA,
        rules: getValidationsByMode(validationRules.requiredValue),
        isLarge: true
      })
    } else {
      this.fullscreen = false
    }
    this.currentCrudDialogMode = mode
  }

  async handleSubmit (eventData: CrudFormField[]) {
    let success = false
    switch (this.currentCrudDialogMode) {
      case CrudDialogMode.CREATE:
        success = await this.executeCreate(eventData)
        break
      case CrudDialogMode.EDIT:
        success = await this.executeUpdate(eventData)
        break
      case CrudDialogMode.ACTIVATE:
      case CrudDialogMode.DEACTIVATE:
        success = await this.executeToggleIsActive(eventData)
        break
      case CrudDialogMode.DELETE:
        success = await this.executeToggleIsArchived()
        break
    }
    if (success) {
      this.snackbarMessage = 'הפעולה בוצעה בהצלחה'
      this.closeDialog()
    } else {
      this.snackbarMessage = 'הפעולה נכשלה. אנא ודאו את הטופס'
    }
    this.snackbar = true
  }

  async executeCreate (eventData: CrudFormField[]) {
    return this.createAuthority({ searchText: eventData[0].value })
  }

  async executeUpdate (eventData: CrudFormField[]) {
    return this.updateAuthority(this.updateAuthorityPayload(eventData))
  }

  updateAuthorityPayload (eventData: CrudFormField[]) {
    return { id: this.currentCrudItem.id, ..._.zipObjectDeep(eventData.map(f => f.name), eventData.map(f => f.value)) }
  }

  async executeToggleIsArchived () {
    if (!this.currentCrudItem.id) return false
    return this.archiveAuthority({ id: this.currentCrudItem.id, isArchived: !this.isArchivedTab })
  }

  async executeToggleIsActive (eventData: CrudFormField[]) {
    return this.activateAuthority({ ...this.updateAuthorityPayload(eventData), isActive: !this.isActiveTab })
  }

  async fetchPage (page: number): Promise<void> {
    this.isLoading = true
    await this.fetchAuthorities({
      limit: this.itemsPerPage,
      page,
      isArchived: this.isArchivedTab,
      isActive: this.isActiveTab
    })
    this.isLoading = false
  }

  get currentDialogTitle () {
    switch (this.currentCrudDialogMode) {
      case CrudDialogMode.CREATE:
        return 'יצירת רשות בהקפאה'
      case CrudDialogMode.EDIT:
        return 'עריכת רשות'
      case CrudDialogMode.ACTIVATE:
        return 'להפעיל רשות?'
      case CrudDialogMode.DEACTIVATE:
        return 'להקפיא רשות?'
      case CrudDialogMode.DELETE:
        return this.isArchivedTab ? 'לשחזר?' : 'להעביר לארכיון?'
    }
  }

  get detailFields (): DetailsField[] {
    return [
      {
        href: (item: Authority) => item.approvedBusinessesCount ? `/employers?authorityIds=${item.id}&isApproved=true` : '',
        text: 'מעסיקים',
        type: DetailsFieldType.LINK,
        value: 'approvedBusinessesCount'
      },
      {
        href: (item: Authority) => item.relevantBusinessesCount ? `/employers?authorityIds=${item.id}&lastActivityGte=${daysAgoInISO(365)}&isApproved=true` : '',
        text: 'מעסיקים רלוונטיים',
        type: DetailsFieldType.LINK,
        value: 'relevantBusinessesCount'
      },
      {
        href: (item: Authority) => item.new30DaysBusinessesCount ? `/employers?authorityIds=${item.id}&createdAtGte=${daysAgoInISO(30)}&isApproved=true` : '',
        text: 'מעסיקים שנרשמו ב-30 יום האחרונים',
        type: DetailsFieldType.LINK,
        value: 'new30DaysBusinessesCount'
      },
      {
        href: (item: Authority) => item.relevantYouthCount ? `/users?roles=AUTHENTICATED&authorityIds=${item.id}&lastActivityGte=${daysAgoInISO(180)}` : '',
        text: 'בני נוער רלוונטיים',
        type: DetailsFieldType.LINK,
        value: 'relevantYouthCount'
      },
      {
        href: (item: Authority) => item.activeYouthCount ? `/users?roles=AUTHENTICATED&authorityIds=${item.id}&lastActivityGte=${daysAgoInISO(30)}` : '',
        text: 'בני נוער פעילים',
        type: DetailsFieldType.LINK,
        value: 'activeYouthCount'
      },
      {
        href: (item: Authority) => item.new30DaysYouthCount ? `/users?roles=AUTHENTICATED&authorityIds=${item.id}&createdAtGte=${daysAgoInISO(30)}` : '',
        text: 'בני נוער שנרשמו ב-30 יום האחרונים',
        type: DetailsFieldType.LINK,
        value: 'new30DaysYouthCount'
      },
      {
        href: (item: Authority) => item.hourLoggingYouthCount ? `/users?roles=AUTHENTICATED&authorityIds=${item.id}&lastShiftLogGte=${daysAgoInISO(30)}` : '',
        text: 'בני נוער פעילים שרושמים שעות',
        type: DetailsFieldType.LINK,
        value: 'hourLoggingYouthCount'
      },
      {
        href: (item: Authority) => item.jobListingsCount ? `/job-listings?authorityIds=${item.id}` : '',
        text: 'פרסומים פעילים',
        type: DetailsFieldType.LINK,
        value: 'jobListingsCount'
      },
      {
        href: (item: Authority) => item.vacantPositionsCount ? `/job-listings?authorityIds=${item.id}` : '',
        text: 'משרות פעילות לאיוש',
        type: DetailsFieldType.LINK,
        value: 'vacantPositionsCount'
      },
      {
        text: 'יחס',
        type: DetailsFieldType.TEXT,
        value: 'ratio'
      },
      {
        text: 'שם רשמי',
        type: DetailsFieldType.TEXT,
        value: 'gmapsName'
      },
      {
        action: async (item: Authority) => this.updateAuthority({ id: item.id, notes: item.notes }),
        text: 'הערות',
        isLarge: true,
        type: DetailsFieldType.TEXT_AREA,
        value: 'notes'
      },
      {
        text: 'שם ראש העיר',
        isLarge: false,
        type: DetailsFieldType.TEXT,
        value: 'mayor'
      },
      {
        text: 'תמונת ראש העיר',
        isLarge: false,
        type: DetailsFieldType.IMAGE,
        value: 'mayorPic'
      },
      {
        text: 'תמונת לוגו הרשות',
        isLarge: false,
        type: DetailsFieldType.IMAGE,
        value: 'logo'
      },
      {
        text: 'דבר הרשות',
        isLarge: true,
        type: DetailsFieldType.TEXT,
        value: 'message'
      },
      {
        text: 'מאמר מוביל',
        isLarge: true,
        type: DetailsFieldType.TEXT,
        value: ''
      },
      {
        text: 'כותרת',
        isLarge: false,
        type: DetailsFieldType.TEXT,
        value: 'leadArticle.title'
      },
      {
        text: 'כותרת משנית',
        isLarge: false,
        type: DetailsFieldType.TEXT,
        value: 'leadArticle.subtitle'
      },
      {
        text: 'טקסט',
        isLarge: true,
        type: DetailsFieldType.TEXT,
        value: 'leadArticle.text'
      },
      {
        text: 'תמונת מאמר',
        isLarge: true,
        type: DetailsFieldType.IMAGE,
        value: 'leadArticle.image'
      }
    ]
  }

  get formattedAuthorities (): Authority[] {
    return this.authorities.map(authority => ({
      ...authority,
      shortNotes: _.words(authority.notes).length > 5 ? `${_.words(authority.notes).slice(0, 5).join(' ')}...` : authority.notes,
      ratio: stringRatio(authority.availableYouthCount, authority.vacantPositionsCount)
    }))
  }

  get dialog () {
    return this.currentCrudDialogMode !== CrudDialogMode.NONE
  }

  get isArchivedTab () {
    return this.currentTab === 2
  }

  get isActiveTab () {
    return this.currentTab === 0
  }

  get isInactiveTab () {
    return this.currentTab === 1
  }

  get tableActions (): DataTableAction<Authority>[] {
    const actions = [this.editActions]

    if (this.isActiveTab) {
      actions.push(this.activationActions)
    } else if (this.isInactiveTab) {
      actions.push(this.activationActions, this.archiveActions)
    } else {
      actions.push(this.archiveActions)
    }

    return actions
  }

  get archiveActions (): DataTableAction<Authority> {
    return {
      text: this.isArchivedTab ? 'שחזור' : 'העברה לארכיון',
      icon: this.isArchivedTab ? 'mdi-backup-restore' : 'mdi-archive',
      handler: this.openDialog.bind(this, CrudDialogMode.DELETE)
    }
  }

  get activationActions (): DataTableAction<Authority> {
    if (this.isActiveTab) {
      return { text: 'הקפאה', icon: 'mdi-bank-off', handler: this.openDialog.bind(this, CrudDialogMode.DEACTIVATE) }
    }
    return { text: 'הפעלה', icon: 'mdi-bank', handler: this.openDialog.bind(this, CrudDialogMode.ACTIVATE) }
  }

  get editActions (): DataTableAction<Authority> {
    return {
      text: 'עריכה',
      icon: 'mdi-pencil',
      handler: this.openDialog.bind(this, CrudDialogMode.EDIT)
    }
  }
}
